import { CheckIcon, EditIcon } from "fe-shared/src/components/Icons";
import { PermissionLevel } from "fe-shared/src/types/domain";
import {
  CorrectionsAction,
  CorrectionsActionConfig,
  TransactionStatus,
} from "fe-shared-transactions/src/types";
import { PERMISSIONS } from "consts";

const { Add, Submit, EditCorrection } = CorrectionsAction;

const { Suspended, Submitted } = TransactionStatus;

export const actions: CorrectionsActionConfig[] = [
  {
    name: Add,
    isVisible: (t, c) => {
      const isSubmitted = t.statusCode === Submitted && t.isAdjustable;
      const isSuspended = t.statusCode === Suspended;
      const isEmptyCorrections = !c.lastModifiedBy && !c.isDraft;
      const isCorrectionStatus = isSubmitted || isSuspended;

      return isCorrectionStatus && isEmptyCorrections;
    },
    hasConfirmationDialog: true,
    buttonProps: {
      iconComponent: EditIcon,
    },
    permission: {
      name: PERMISSIONS.addCorrection,
      level: PermissionLevel.Full,
    },
  },
  {
    name: EditCorrection,
    isVisible: (transaction, corrections, company) => {
      const { statusCode, isAdjustable } = transaction;

      const isSubmitted = statusCode === Submitted && isAdjustable;
      const isSuspended = statusCode === Suspended;
      const isCorrectionsStatus = isSubmitted || isSuspended;
      const isCorrectionExists = !!corrections?.lastModifiedBy;
      const isCorrectionSubmitted = corrections?.isSubmitted;
      const isCurrentCompanyModified =
        corrections?.lastModifiedByCompanyId === company?.companyId;
      const isCorrectionEditState =
        !isCorrectionSubmitted && !isCurrentCompanyModified;

      const isUpdateEnable =
        isCorrectionExists && (isCorrectionEditState || isCorrectionSubmitted);

      return isCorrectionsStatus && (isUpdateEnable || corrections.isDraft);
    },
    hasConfirmationDialog: true,
    buttonProps: {
      iconComponent: EditIcon,
    },
    permission: {
      name: PERMISSIONS.addCorrection,
      level: PermissionLevel.Full,
    },
  },
  {
    name: Submit,
    isVisible: (transaction, corrections, company) => {
      const isCorrectionsStatus = [Submitted, Suspended].includes(
        transaction.statusCode
      );
      const isCorrectionsExist = !!corrections.lastModifiedBy;
      const isCurrentCompanyModified =
        corrections?.lastModifiedByCompanyId === company?.companyId;
      const isDraftSubmit = isCorrectionsStatus && corrections.isDraft;
      const isCorrectionApprove =
        isCorrectionsExist &&
        isCorrectionsStatus &&
        !corrections.isSubmitted &&
        !isCurrentCompanyModified;

      return isDraftSubmit || isCorrectionApprove;
    },
    hasConfirmationDialog: false,
    buttonProps: {
      iconComponent: CheckIcon,
    },
    permission: {
      name: PERMISSIONS.submitCorrection,
      level: PermissionLevel.Full,
    },
  },
];

export default actions;
